import { call, put } from 'redux-saga/effects';
import { switchActiveSheet } from '../../../../windows/redux/windowsSlice';
import { SheetCommandType } from '../../../types/commands/sheetCommands/sheetCommands';
import { SheetGroupsCommandType } from '../../../types/commands/sheetGroupsCommands/sheetGroupCommands';
import { SheetManagementSet } from '../../../types/sheet/draft';
import { generateNewGroup } from '../../../utils/commands/generate/common';
import { getUniqueEntityName } from '../../../utils/entityIdToName/entityIdToName';
import { generateSheet } from '../../../utils/sheet/metaData';
import { generateSheetsDataSet } from '../root/rootHelpers';
import { startCreateNewSheet } from './compositeCommandsActions';
import { startUpdateSheetsState } from '../root/root';
import {
  addSheetToGroup,
  createSheetGroup,
} from '../../../utils/commands/execute/sheetGroupCRUD';
import { createSheet } from '../../../utils/commands/execute/sheetCRUD';

export function* startCreateNewSheetMi({
  payload,
}: ReturnType<typeof startCreateNewSheet>) {
  let { groupId, windowId } = payload;

  const set: SheetManagementSet = yield generateSheetsDataSet();

  //   #1 Create Group if no groupId is passed as param
  if (!groupId) {
    const group = generateNewGroup(set.staticEntityIdToNameMap.groupsIdToName);
    yield createSheetGroup(set, {
      type: SheetGroupsCommandType.CreateGroup,
      group,
    });
    groupId = group.id;
  }

  //   #2 Create Sheet
  const sheet = generateSheet(
    set.userId,
    getUniqueEntityName(set.staticEntityIdToNameMap.sheetsIdToName)
  );

  yield createSheet(set, {
    type: SheetCommandType.CreateSheet,
    sheet: sheet,
    groupId,
  });

  //   #3 Add Sheet id into group
  yield addSheetToGroup(set, {
    type: SheetGroupsCommandType.AddSheetToGroup,
    sheetId: sheet.id,
    groupId,
  });

  yield call(startUpdateSheetsState, set);

  //   #4 Switch active sheet if window Id exists
  if (windowId) {
    yield put(switchActiveSheet({ id: windowId, sheetId: sheet.id }));
  }
}
